import { selectTags } from './reducers';
export default selectTags;
